<template>
  <div :class="{ login: !isCustomOwner, 'login-volvo': isCustomOwner }">
    <img
      v-if="isCustomOwner"
      class="flit2go-logo"
      src="@/flit2go-web-core/assets/flit2goLogoWhite.svg"
      alt="f2gLogo"
    />
    <transition name="fade">
      <v-card
        class="elevation-20"
        :class="{
          login__card: !isCustomOwner,
          login__card__volvo: isCustomOwner,
        }"
      >
        <v-layout>
          <div class="login__card__form">
            <form id="login">
              <!-- reset password -->
              <div v-show="resetPassword && !showMfa">
                <v-layout justify-center>
                  <img
                    v-if="isCustomOwner"
                    class="login__card__logo__volvo"
                    src="@/flit2go-web-core/assets/logo-volvo.svg"
                    alt="VolvoLogo"
                  />
                  <img
                    v-else
                    class="login__card__form__logo"
                    src="@/flit2go-web-core/assets/flit2goLogo.svg"
                    alt="f2gLogo"
                  />
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <h1>{{ $t("role.manager") }}</h1>
                </v-layout>
                <v-layout justify-center>
                  <span
                    class="text-bold"
                    v-html="$t('forms.enterNewPassword')"
                  ></span>
                </v-layout>
                <v-layout justify-center>
                  <v-text-field
                    type="password"
                    :color="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    v-model="newPassword.password"
                    id="exampleInputPassword1"
                    :label="$t('forms.password')"
                    prepend-inner-icon="lock"
                    required
                    @keyup.enter="changePassword"
                  ></v-text-field>
                </v-layout>
                <v-flex xs12>
                  <v-layout justify-center>
                    <v-text-field
                      type="password"
                      v-model="password"
                      :color="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                      id="exampleInputPassword2"
                      :label="$t('forms.passwordRepeat')"
                      prepend-inner-icon="lock"
                      required
                      @keyup.enter="changePassword"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-layout>
                  <F2gButton
                    class="login__card__form__button"
                    :customClass="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    :textColor="!isCustomOwner ? '' : 'f2gGreen'"
                    :loading="loading"
                    :text="$t('common.changePassword')"
                    @click="changePassword"
                  />
                </v-layout>
                <v-layout justify-center>
                  <h4
                    class="login__card__form__error"
                    v-show="errorMessage.length > 0"
                  >
                    {{ errorMessage }}
                  </h4>
                </v-layout>
              </div>
              <!-- forgotten password -->
              <div v-show="forgottenPassword && !resetPassword && !showMfa">
                <v-layout justify-center>
                  <img
                    v-if="isCustomOwner"
                    class="login__card__logo__volvo"
                    src="@/flit2go-web-core/assets/logo-volvo.svg"
                    alt="VolvoLogo"
                  />
                  <img
                    v-else
                    class="login__card__form__logo"
                    src="@/flit2go-web-core/assets/flit2goLogo.svg"
                    alt="f2gLogo"
                  />
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <h1 v-html="$t('role.manager')"></h1>
                </v-layout>
                <v-layout justify-center class="mb-4">
                  <span
                    class="text-bold"
                    v-html="$t('common.insertEmail')"
                  ></span>
                </v-layout>
                <v-layout align-center class="mb-2">
                  <v-text-field
                    type="text"
                    v-model="email"
                    :color="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    :label="$t('forms.email')"
                    prepend-inner-icon="person"
                    required
                    class
                    @keyup.enter="recoverPassword"
                  ></v-text-field>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-layout class="mr-1">
                      <F2gButton
                        class="login__card__form__button"
                        :customClass="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                        :textColor="!isCustomOwner ? '' : 'f2gGreen'"
                        :loading="loading"
                        :text="$t('common.submit')"
                        @click="recoverPassword"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs6>
                    <v-layout class="ml-1">
                      <F2gButton
                        class="login__card__form__button"
                        customClass="error"
                        outline
                        :text="$t('common.cancel')"
                        @click="
                          () => {
                            clear(true);
                            forgottenPassword = false;
                          }
                        "
                      />
                    </v-layout>
                  </v-flex>
                  <v-layout justify-center>
                    <h4
                      class="login__card__form__error"
                      v-show="errorMessage.length > 0"
                    >
                      {{ errorMessage }}
                    </h4>
                  </v-layout>
                </v-layout>
              </div>
              <!-- login -->
              <div v-show="!forgottenPassword && !resetPassword && !showMfa">
                <v-layout justify-center>
                  <img
                    v-if="isCustomOwner"
                    class="login__card__logo__volvo"
                    src="@/flit2go-web-core/assets/logo-volvo.svg"
                    alt="VolvoLogo"
                  />
                  <img
                    v-else
                    class="login__card__form__logo"
                    src="@/flit2go-web-core/assets/flit2goLogo.svg"
                    alt="f2gLogo"
                  />
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <h1 v-html="$t('role.manager')"></h1>
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    type="text"
                    v-model="email"
                    :color="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    id="exampleInputEmail2"
                    aria-describedby="emailHelp"
                    :label="$t('forms.email')"
                    prepend-inner-icon="person"
                    required
                    @keyup.enter="eventLogin"
                  ></v-text-field>
                </v-layout>
                <v-layout justify-center>
                  <v-text-field
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    :color="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    id="exampleInputPassword3"
                    :label="$t('forms.password')"
                    prepend-inner-icon="lock"
                    required
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="eventLogin"
                  ></v-text-field>
                </v-layout>
                <v-layout justify-center>
                  <F2gButton
                    class="login__card__form__button"
                    :customClass="!isCustomOwner ? 'f2gGreen' : 'blueVolvo'"
                    :textColor="!isCustomOwner ? '' : 'f2gGreen'"
                    :loading="loading"
                    :text="$t('common.submit')"
                    @click="eventLogin"
                  />
                </v-layout>
                <v-layout justify-center>
                  <h4
                    class="login__card__form__error"
                    v-show="errorMessage.length > 0"
                  >
                    {{ errorMessage }}
                  </h4>
                </v-layout>
                <v-layout justify-center>
                  <h4
                    class="login__card__form__forgotPassword"
                    v-html="$t('common.forgotPassword')"
                    @click="
                      () => {
                        clear(true);
                        forgottenPassword = true;
                      }
                    "
                  ></h4>
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <hr class="mb-4" />
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <h4 v-html="$t('common.followSocial')"></h4>
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <a href="https://flit2go.com" target="_blank">
                    <v-btn fab small color="white">
                      <v-img
                        class="login__card__form_social"
                        :src="
                          require('@/flit2go-web-core/assets/login/web.png')
                        "
                        :contain="true"
                        max-width="20px"
                      ></v-img>
                    </v-btn>
                  </a>
                  <a href="https://instagram.com/flit2go" target="_blank">
                    <v-btn fab small color="white" class="ml-3">
                      <v-img
                        class="login__card__form_social"
                        :src="
                          require('@/flit2go-web-core/assets/login/instagram.png')
                        "
                        :contain="true"
                        max-width="20px"
                      ></v-img>
                    </v-btn>
                  </a>
                  <a
                    href="https://linkedin.com/company/flit2go"
                    target="_blank"
                  >
                    <v-btn fab small color="white" class="ml-3">
                      <v-img
                        class="login__card__form_social"
                        :src="
                          require('@/flit2go-web-core/assets/login/linkedin.png')
                        "
                        :contain="true"
                        max-width="20px"
                      ></v-img>
                    </v-btn>
                  </a>
                </v-layout>
                <v-layout justify-center class="pt-3" v-if="!isCustomOwner">
                  <p>
                    <a
                      href="https://flit2go.com/aviso-legal/"
                      v-html="$t('common.legalAdvice')"
                      target="_blank"
                      class="links"
                      style="margin-right: 5px"
                    />
                    <a
                      href="https://flit2go.com/politica-de-privacidad/"
                      v-html="$t('common.privacyPolitic')"
                      target="_blank"
                      class="links"
                      style="margin-left: 5px"
                    />
                  </p>
                </v-layout>
              </div>
              <!-- MFA -->
              <div v-if="showMfa">
                <v-layout justify-center>
                  <img
                    v-if="isCustomOwner"
                    class="login__card__logo__volvo"
                    src="@/flit2go-web-core/assets/logo-volvo.svg"
                    alt="VolvoLogo"
                  />
                  <img
                    v-else
                    class="login__card__form__logo"
                    src="@/flit2go-web-core/assets/flit2goLogo.svg"
                    alt="f2gLogo"
                  />
                </v-layout>
                <v-layout justify-center v-if="!isCustomOwner">
                  <h1 v-html="$t('role.manager')"></h1>
                </v-layout>
                <v-layout justify-center>
                  <div class="flex-col">
                    <div class="text text-center">
                      {{ $t("common.mfaCodeText") }}
                    </div>
                    <div class="mt-4">
                      <MfaVerificator
                        @validateToken="eventValidateToken"
                        :isCustomOwner="isCustomOwner ? true : false"
                      />
                    </div>
                  </div>
                </v-layout>
              </div>
            </form>
          </div>
        </v-layout>
      </v-card>
    </transition>
    <!-- popup recover password -->
    <transition name="fade">
      <PopUpRecoverPassword
        v-if="showPopUp"
        class="popup-password"
        :show="showPopUp"
        :email="email"
        :passwordChanged="resetPassword"
        :isCustomOwner="isCustomOwner ? true : false"
        @closePopUp="closePopUp"
      ></PopUpRecoverPassword>
    </transition>
    <!-- captcha -->
    <div
      :data-sitekey="captchaKey"
      data-size="invisible"
      id="recaptcha-div"
    ></div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import auth from "@/base/config-auth";
import menuStructureFile from "@/base/menuStructure/menuStructure.js";
import MfaVerificator from "@/flit2go-web-core/components/ui/mfaVerificator";
import PopUpRecoverPassword from "@/flit2go-web-core/components/popup-recover-password";
import initZohoSalesIQ from "@/util/initZohoSalesIQ.js";
import pagesense from "@/services/pagesense.js";
import zohoDeskAsap from "@/flit2go-web-core/services/zohoDeskAsapService.js";
import { HELP_CENTER_LOGIN } from "@/base/routesInterface";

export default {
  name: "Index-login",
  components: { PopUpRecoverPassword, MfaVerificator },
  data: () => ({
    captchaKey: process.env.VUE_APP_CAPTCHA,
    created: false,
    correctCaptcha: false,
    email: "",
    password: "",
    loading: false,
    resetPassword: false,
    forgottenPassword: false,
    showPopUp: false,
    errorMessage: "",
    menuStructureFile,
    newPassword: {
      id: "",
      token: "",
      password: "",
    },
    showMfa: false,
    mfaToken: null,
    mfaPhone: "",
    showPassword: false,
  }),
  async created() {
    this.initScriptCaptcha();
    if (this.$route.query.hasOwnProperty("token")) {
      this.email = this.$route.query.email;
      this.loading = true;
      this.resetPassword = true;
      var idUser = await this.getPersonByUsername();
      this.newPassword.token = this.$route.query.token;
      if (idUser) {
        this.newPassword.id = idUser;
      } else {
        this.errorMessage = this.$t("errors.emailNotExist");
      }
      this.loading = false;
    }
  },
  beforeDestroyed() {
    if (process.env.VUE_APP_MODE !== "development") {
      document.getElementById("recaptcha-div").classList.remove("g-recaptcha");
      document.getElementById("captchaScript").remove();
    }
  },
  computed: {
    ...mapState(["auth"]),
    ...mapGetters({
      ownerColors: "auth/getOwnerColors",
    }),
    isCustomOwner() {
      if (window.location.href.includes("volvo")) {
        return "volvo";
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      validateMfa: "auth/validateMfa",
      getMFALogin: "auth/getMfaLogin",
    }),
    closePopUp() {
      this.showPopUp = false;
      if (this.resetPassword) {
        this.login();
      }
    },
    async getPersonByUsername() {
      try {
        let response = await this.$store.dispatch(
          "auth/getPersonIdByUsername",
          { username: this.email, client_ID: auth.client_id },
        );
        return response.data;
      } catch (error) {
        return null;
      }
    },
    clear(boolean) {
      if (boolean) {
        this.email = "";
        this.password = "";
      }
      this.newPassword.id = "";
      this.newPassword.token = "";
      this.newPassword.password = "";
      this.errorMessage = "";
      this.loading = false;
      this.showPopUp = false;
      // eslint-disable-next-line
      grecaptcha.reset();
    },
    changePassword() {
      if (this.newPassword.password && this.password) {
        const isPasswordValid =
          this.password.length >= 8 && this.password.length <= 40;
        const isNewPasswordValid =
          this.newPassword.password.length >= 8 &&
          this.newPassword.password.length <= 40;
        const arePasswordsEquals = this.newPassword.password === this.password;

        if (!isPasswordValid || !isNewPasswordValid) {
          this.errorMessage = this.$t("errors.passwordLength");
          return;
        }
        if (arePasswordsEquals) {
          this.errorMessage = "";
          this.loading = true;
          this.$store
            .dispatch("auth/resetUserPassword", this.newPassword)
            .then(() => {
              this.showPopUp = true;
            })
            .catch(() => {
              this.loading = false;
              this.errorMessage = this.$t("errors.changeLinkPassword");
            });
        } else {
          this.errorMessage = this.$t("errors.passwordsNotMatch");
        }
      } else {
        this.errorMessage = this.$t("errors.notPasswords");
      }
    },
    async recoverPassword() {
      if (this.email) {
        this.clear(false);
        this.loading = true;
        var idUser = await this.getPersonByUsername();
        if (idUser) {
          this.$store
            .dispatch("auth/sendEmailToUser", idUser)
            .then(() => {
              this.loading = false;
              this.showPopUp = true;
            })
            .catch(() => {
              this.loading = false;
              this.errorMessage = this.$t("errors.errorSendEmail");
            });
        } else {
          this.loading = false;
          this.errorMessage = this.$t("errors.emailNotExist");
        }
      } else {
        this.errorMessage = this.$t("errors.mustInsertEmail");
      }
    },
    async checkCaptcha() {
      if (this.created) {
        // eslint-disable-next-line
        var captchaResponse = await grecaptcha.getResponse();
        if (captchaResponse.length > 0) {
          this.correctCaptcha = true;
        } else {
          this.correctCaptcha = false;
        }
      } else {
        this.created = true;
        this.correctCaptcha = true;
      }
    },
    getTokenForFirstLogin() {
      this.newPassword.id = this.$store.state.auth.userProfile.id;
      this.$store
        .dispatch("auth/tokenForFirstLogin", this.newPassword.id)
        .then((resp) => {
          this.newPassword.token = resp.data;
          this.resetPassword = true;
        })
        .catch(() => {
          this.errorMessage = this.$t(this.$CONSTANTS.ERROR.GENERIC);
        })
        .finally(() => {
          this.loading = false;
          this.password = "";
          this.$store.dispatch("auth/AUTH_LOGOUT");
        });
    },
    initScriptCaptcha() {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?onload=initCaptcha";
      script.async = true;
      script.defer = true;
      script.id = "captchaScript";
      document.head.appendChild(script);
      window.login = this.login;
      window.initCaptcha = this.initCaptcha;
    },
    initCaptcha() {
      // eslint-disable-next-line
      grecaptcha.ready(() => {
        document.getElementById("recaptcha-div").classList.add("g-recaptcha");
        // eslint-disable-next-line
        grecaptcha.render("recaptcha-div");
      });
    },
    async eventLogin() {
      await this.checkCaptcha();
      if (this.correctCaptcha) {
        if (!this.email || !this.password) {
          this.errorMessage = this.$t("errors.incorrectData");
        } else {
          this.clear(false);
          this.loading = true;

          const hasMfa = await this.hasMFA();

          if (!hasMfa) {
            this.login();
          } else {
            this.loading = false;
          }
        }
      } else {
        // eslint-disable-next-line
        grecaptcha.reset();
        // eslint-disable-next-line
        grecaptcha.execute();
      }
    },
    async hasMFA() {
      return new Promise((resolve) => {
        let payloadMfa = { userName: this.email };
        this.getMFALogin(payloadMfa)
          .then((resp) => {
            this.showMfa = resp.hasMfa;
            resolve(resp.hasMfa);
          })
          .catch((err) => {
            if (err.bannedUser) {
              this.$showMessage.error(err.bannedText);
            } else {
              // usuario no existe
              this.loading = false;
              this.errorMessage = this.$t("errors.incorrectData");
              // eslint-disable-next-line
              grecaptcha.reset();
              // eslint-disable-next-line
              grecaptcha.execute();
            }
          });
      });
    },
    eventValidateToken(token) {
      this.mfaToken = token;
      this.login();
    },
    login() {
      const { email, password, mfaToken } = this;
      this.$store
        .dispatch("auth/AUTH_LOGIN", { email, password, mfaToken })
        .then(() => {
          if (this.$store.state.auth.userProfile.passwordReset) {
            this.created = false;
            this.getTokenForFirstLogin();
          } else {
            initZohoSalesIQ(this.$store.state.auth.userProfile);
            pagesense.identifyUser(this.$store.state.auth.userProfile);
            zohoDeskAsap.identifyUser();
            if (process.env.NODE_ENV === "production") {
              this.$gtag.config({
                user_id: this.$store.state.auth.userProfile.id.toString(),
              });
              this.$gtag.customMap({
                dimension1: this.$store.getters["auth/getUserAuthoritye"],
              });
            }
            this.$store
              .dispatch("settings/CHANGE_LANG", {
                id: this.$store.state.auth.userProfile.id,
                language: this.$store.state.auth.userProfile.language,
              })
              .then(() => {
                this.$store.dispatch("settings/getLanguages").finally(() => {
                  this.getSetRoleSchema();
                });
              });
          }
        })
        .catch((err) => {
          this.$showMessage.error(
            err.response.data.errorDescription
              ? err.response.data.errorDescription
              : err.response.data,
          );
          this.showMfa = false;
          this.loading = false;
          this.password = "";
          this.errorMessage = this.$t("errors.incorrectData");

          // eslint-disable-next-line
          grecaptcha.reset();
          // eslint-disable-next-line
          grecaptcha.execute();
        });
    },
    getSetRoleSchema() {
      this.$store
        .dispatch("auth/getSetRoleSchema")
        .then(() => this.redirectToFirstLinkAllowed());
    },
    redirectToFirstLinkAllowed() {
      // Coming from the Zoho help center portal: go back to its login page to finish the sign-in
      const redirect = this.$route.query.redirect;
      if (typeof redirect === "string" && redirect.startsWith(HELP_CENTER_LOGIN)) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.menuStructureFile.getFirstLinkAllowed());
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-btn {
  color: rgba(255, 255, 255, 0.87);
}
.login {
  min-height: 100vh;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: url("../../flit2go-web-core/assets/login/fondo_login.svg")
    no-repeat center center fixed;
  -webkit-background-size: cover;
  -webkit-background-color: white !important;
  background-color: white !important;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.login-volvo {
  min-height: 100vh;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: url("../../flit2go-web-core/assets/login/volvo.svg") no-repeat
    center center fixed;
  background-color: white !important;
  -webkit-background-size: cover;
  -webkit-background-color: white !important;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  .flit2go-logo {
    object-fit: cover;
    margin: auto;
    bottom: 85px;
    right: 20px;
    height: 70px;
    width: 240px;
    position: absolute;
  }
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 20;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .lds-facebook {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 13px;
    background: #1c8523;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .lds-facebook div:nth-child(1) {
    left: 6px;
    animation-delay: -0.24s;
  }
  .lds-facebook div:nth-child(2) {
    left: 26px;
    animation-delay: -0.12s;
  }
  .lds-facebook div:nth-child(3) {
    left: 45px;
    animation-delay: 0;
  }
}

h1,
h3,
h4,
.links {
  font-size: 1.25em;
  color: grey;
  font-weight: 300;
  margin: -0.5em 0 0.75em 0;
}

.links {
  font-size: 14px;
}

hr {
  width: 60%;
  opacity: 0.5;
  color: grey;
}

.text-bold {
  font-weight: bold;
  font-weight: 400;
  font-size: 1.25em;
}

h4 {
  font-size: 1em;
}

.login__card {
  min-height: 66vh;
  width: 35vw;
  border-radius: 25px !important;
}

.login__card__volvo {
  min-height: 50vh;
  width: 35vw;
  border-radius: 25px;
}

.login__card__form {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  width: 100%;
  padding: 75px 75px;
}

.login__card__form__logo {
  object-fit: cover;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  height: 90px;
  width: 270px;
}

.login__card__logo__volvo {
  object-fit: cover;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  height: 90px;
  width: 480px;
}

.login__card__form__error {
  color: #b71c1c !important;
  font-size: 1.25em;
  margin-bottom: 20px;
}

.login__card__form__button {
  border-radius: 40px;
  width: 100%;
  margin-bottom: 50px;
  color: white;
  cursor: pointer;
}

.login__card__form__button--half {
  width: 50%;
}

.login__card__form__forgotPassword:hover {
  text-decoration: underline solid grey;
  cursor: pointer;
}

.login__card__form_social {
  padding-top: 40px;
  width: 30px;
  height: 30px;
}

.popup-password {
  z-index: 20px;
  position: absolute;
}

@media (max-width: 1120px) {
  .login__card {
    min-height: 66vh;
    width: 90vw;
    border-radius: 25px;
  }
  .login__card__volvo {
    min-height: 66vh;
    width: 90vw;
    border-radius: 25px;
  }
}

@media (max-width: 685px) {
  .login__card {
    min-height: 66vh;
    width: 95vw;
    border-radius: 25px;
  }
  .login__card__volvo {
    min-height: 66vh;
    width: 95vw;
    border-radius: 25px;
  }

  hr {
    color: grey;
    width: 95%;
  }
  .login-volvo {
    min-height: 100vh;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    background: url("../../flit2go-web-core/assets/login/volvo.svg") no-repeat
      center center fixed;
    background-color: white !important;
    -webkit-background-size: cover;
    -webkit-background-color: white !important;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .flit2go-logo {
      object-fit: cover;
      margin: auto;
      bottom: 15px;
      right: 200px;
      height: 50px;
      width: 190px;
      position: absolute;
    }
  }
}

@media (max-height: 800px) {
  .login__card {
    min-height: 80vh;
  }
  .login__card__volvo {
    min-height: 80vh;
  }

  .login__card__form {
    padding: 50px 75px;
  }

  .login__card__form__logo {
    object-fit: cover;
    margin-bottom: 5px;
    height: 90px;
    width: 270px;
  }

  .login__card__form__button {
    margin-bottom: 20px;
  }
  .login-volvo {
    min-height: 100vh;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    background: url("../../flit2go-web-core/assets/login/volvo.svg") no-repeat
      center center fixed;
    background-color: white !important;
    -webkit-background-size: cover;
    -webkit-background-color: white !important;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .flit2go-logo {
      object-fit: cover;
      margin: auto;
      bottom: 5px;
      right: 210px;
      height: 50px;
      width: 150px;
      position: absolute;
    }
  }
}

@media (max-width: 500px) {
  .login__card {
    width: 90vw;
  }
  .login__card__volvo {
    width: 90vw;
  }
}

@media (max-width: 380px) {
  .login__card {
    width: 95vw;
  }
  .login__card__volvo {
    width: 95vw;
  }
}

@media (max-height: 640px) {
  .login__card {
    min-height: 90vh;
  }
  .login__card__volvo {
    min-height: 90vh;
  }

  .login__card__form {
    padding: 20px 75px;
  }

  .login__card__form__logo {
    object-fit: cover;
    margin: auto;
    height: 90px;
    width: 270px;
  }

  .login__card__form__button {
    margin-bottom: 20px;
  }
  .flit2go-logo {
    object-fit: cover;
    margin: auto;
    bottom: 85px;
    left: 20px;
    height: 50px;
    width: 220px;
    position: absolute;
  }
}

@media (max-height: 500px) {
  .login__card {
    min-height: 90vh;
  }
  .login__card__volvo {
    min-height: 90vh;
  }

  .login__card__form {
    padding: 20px 75px;
  }

  .login__card__form__logo {
    object-fit: cover;
    margin: auto;
    height: 60px;
    width: 200px;
  }

  .login__card__form__button {
    margin-bottom: 20px;
  }
}

@media (max-height: 400px) {
  .login__card {
    min-height: 97vh;
  }
  .login__card__volvo {
    min-height: 97vh;
  }

  .login__card__form {
    padding: 10px 75px;
  }

  .login__card__form__logo {
    object-fit: cover;
    margin: auto;
    height: 40px;
    width: 120px;
  }

  .login__card__form__button {
    margin-bottom: 10px;
  }

  .login__card__form_social {
    padding-top: 0px;
  }
}

@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
</style>
